import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './services.css';

const servicesData = [
  {
    id: 1,
    title: 'Ciências  da Saúde',
    description: 'Explore as oportunidades de aprendizado, os desafios e as perspectivas de carreira neste campo dinâmico e crucial para o bem-estar da sociedade.'
  },
  {
    id: 2,
    title: 'Ciências Das Engenharia e Tecnologias',
    description: 'Conheça as últimas tendências, os projetos mais impactantes e as oportunidades de carreira que aguardam aqueles que se aventuram nesse emocionante mundo da ciência e da tecnologia.'
  },
  {
    id: 3,
    title: 'Pedagogia',
    description: 'Explore a Pedagogia: transformando a educação com métodos inovadores e inspiradores para o desenvolvimento das futuras gerações.'
  },
  {
    id: 5,
    title: 'Sociologia',
    description: 'A Sociologia analisa questões como cultura, poder, desigualdade, mudança social e dinâmicas de grupo, oferecendo insights valiosos para compreendermos melhor o mundo em que vivemos e as relações que o permeiam.'
  },
  {
    id: 6,
    title: 'Licenciatura em Direito',
    description: 'Desvende a Licenciatura em Direito: explorando a justiça, a ética e os desafios contemporâneos do sistema legal.'
  },
  {
    id: 7,
    title: 'Gestão de Empresas',
    description: 'Descubra a Gestão de Empresas: estratégia, inovação e liderança para impulsionar o sucesso organizacional.'
  },
  {
    id: 8,
    title: 'Gestão Recursos Humanos',
    description: 'Desvende a Gestão de Recursos Humanos: cultivando talentos, promovendo o engajamento e impulsionando o crescimento das organizações.'
  },
  {
    id: 9,
    title: 'Economia',
    description: 'Explore a Economia: análise, tendências e impactos globais nas decisões financeiras e políticas.'
  },
  {
    id: 10,
    title: 'Enfermagem',
    description: 'Descubra a Enfermagem: cuidado, inovação e dedicação para promover a saúde e o bem-estar da comunidade.'
  },
  {
    id: 11,
    title: 'Análises Clínicas',
    description: 'Explore Análises Clínicas: diagnóstico preciso, inovação laboratorial e contribuição para a saúde pública.'
  },
  {
    id: 12,
    title: 'Engenharia Informática',
    description: 'Desbrave a Engenharia Informática: inovação digital, tecnologia de ponta e soluções para os desafios do mundo moderno.'
  },
  {
    id: 13,
    title: 'Farmácia',
    description: 'Desvende a Farmácia: cuidado com a saúde, inovação farmacêutica e contribuição para o bem-estar da sociedade.'
  }
];

const iconMap = {
  'Ciências  da Saúde': 'fas fa-heartbeat',
  'Ciências Das Engenharia e Tecnologias': 'fas fa-cogs',
  'Pedagogia': 'fas fa-chalkboard-teacher',
  'Sociologia': 'fas fa-users',
  'Licenciatura em Direito': 'fas fa-balance-scale',
  'Gestão de Empresas': 'fas fa-briefcase',
  'Gestão Recursos Humanos': 'fas fa-user-tie',
  'Economia': 'fas fa-chart-line',
  'Enfermagem': 'fas fa-user-nurse',
  'Análises Clínicas': 'fas fa-vials',
  'Engenharia Informática': 'fas fa-laptop-code',
  'Farmácia': 'fas fa-pills'
};

function AppServices() {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: false,
    rootMargin: '0px 0px -20% 0px'
  });

  return (
    <motion.section
      ref={ref}
      id="services"
      className="block services-block"
      style={{
        background: 'linear-gradient(135deg, #e0ffe7 0%, #f7f7f7 100%)',
        padding: '60px 0',
        border: 'none'
      }}
      initial={{ opacity: 0, y: 100 }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 100 }}
      transition={{ duration: 0.8, ease: 'easeInOut' }}
    >
      <Container fluid>
        <div
          className="title-holder-modern py-5 px-3 px-md-4"
          style={{
            textAlign: 'center',
            marginBottom: '2.5rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <h2
            className="section-title"
            style={{
              color: '#00761F',
              fontWeight: '700',
              fontSize: '2.5rem',
              textTransform: 'uppercase'
            }}
          >
            Transforme Seu Futuro Conosco!
          </h2>
          <div
            className="section-subtitle"
            style={{
              marginTop: '14px',
              fontWeight: '500',
              color: '#444',
              fontSize: '1.25rem',
              letterSpacing: '0.5px'
            }}
          >
            Descubra cursos inspiradores e prepare-se para conquistar seus sonhos profissionais
          </div>
          <div
            className="section-underline"
            style={{
              marginTop: '20px',
              width: '60px',
              height: '4px',
              backgroundColor: '#00761F',
              borderRadius: '2px'
            }}
          ></div>
        </div>

        <Row style={{ border: 'none', boxShadow: 'none' }}>
          {servicesData.map((service, index) => (
            <Col
              sm={6}
              md={4}
              className="holder"
              key={service.id}
              style={{
                marginBottom: '30px',
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <motion.div
                className="service-card"
                style={{
                  background: '#fff',
                  borderRadius: '18px',
                  boxShadow: '0 6px 24px rgba(0,0,0,0.07)',
                  padding: '32px 24px',
                  textAlign: 'center',
                  width: '100%',
                  maxWidth: '340px',
                  minHeight: '340px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                initial={{ opacity: 0, y: 40 }}
                animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
              >
                <div
                  className="icon"
                  style={{
                    background: 'linear-gradient(135deg, #00761F 60%, #00c853 100%)',
                    borderRadius: '50%',
                    width: '70px',
                    height: '70px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '18px',
                    boxShadow: '0 2px 12px rgba(0, 118, 31, 0.15)'
                  }}
                >
                  <i
                    className={iconMap[service.title] || 'fas fa-graduation-cap'}
                    style={{ color: '#fff', fontSize: '2rem' }}
                  ></i>
                </div>
                <h3
                  style={{
                    color: '#00761F',
                    fontWeight: '600',
                    fontSize: '1.3rem',
                    marginBottom: '12px',
                    marginTop: '0'
                  }}
                >
                  {service.title}
                </h3>
                <p style={{ color: '#444', fontSize: '1rem', margin: 0 }}>{service.description}</p>
              </motion.div>
            </Col>
          ))}
        </Row>
      </Container>
    </motion.section>
  );
}

export default AppServices;
